<template>
    <section class="content-howitworks container">
        <div class="content-howitworks-title">
            <h1>{{ title }}</h1>
            <div class="content-howitworks-line">
                <span></span>
            </div>
        </div>
        <div class="row content-howitworks-row">
            <div class="col-12 col-md-4 content-howitworks-card" v-for="n,i in cards" :key="i">
                <div class="content-howitworks-item">
                    <div class="content-howitworks-item-number">
                        <img src="@/assets/img/home/step-1.png" alt="" width="70" height="70" v-if="i == 0">
                        <img src="@/assets/img/home/step-2.png" alt="" width="70" height="70" v-if="i == 1">
                        <img src="@/assets/img/home/step-3.png" alt="" width="70" height="70" v-if="i == 2">
                    </div>
                    <div class="content-howitworks-item-text">
                        <h3>{{ n.title }}</h3>
                        <p>{{ n.description }}</p>
                    </div>
                    <div class="content-howitworks-item-img">
                        <img :src="n.card_path" alt="howitworks">
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
  export default {
    name: 'HowItWorks',
    components: {
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        cards: {
            type: Array,
            default: () => {}
        },
    },
  }
</script>
<style lang="scss">
.content-howitworks{
    width: 100%;
    height: 100%;
    margin-top: 80px;
    @media screen and (max-width: 992px) {
        padding-left: 25px;
        padding-right: 25px;
    }
    &-title {
        text-align: left;
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        width: 100%;
        white-space: nowrap;
        @media screen and (max-width: 992px) {
          flex-direction: column;
          white-space: normal;
          align-items: flex-start;
        }
    }
    &-line {
        width: 100%;
        height: 2px;
        background-color:var(--main-color);
        margin-bottom: 20px;
        margin-left: 20px;
        @media screen and (max-width: 992px) {
          margin-left: 0;
        }
        span {
            width: 100%;
            height: 2px;
            background-color:var(--main-color);
        }
    }
    &-row{
        justify-content: space-evenly;
    }
    &-card{
        margin-top: 80px;
        height: 510px;
        max-width: 431px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        @media screen and (max-width: 992px) {
            height: 340px;
            margin-top: 50px;
            padding: 20px 0;
            
        }
        .content-howitworks-item{
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            &-number{
                width: 100%;
                height: 80px;
                display: flex;
                justify-content: center;
                align-items: center;
                svg{
                    width: 70px;
                    height: auto;
                    @media screen and (max-width: 992px) {
                        width: 45px;
                        margin-bottom: 25px;
                    }
                }
            }
            &-text{
                margin-top: 40px;
                width: 100%;
                height: 175px;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                @media screen and (max-width: 992px) {
                    margin-top: 0;
                }
                h3{
                    height: 90px;
                    text-transform: uppercase;
                    line-height: 40px;
                    @media screen and (max-width: 992px) {
                        font-size: 20px;
                        line-height: 30px;
                    }
                }
                p{
                    line-height: 30px;
                    font-size: 22px;
                    @media screen and (max-width: 992px) {
                        font-size: 16px;
                        line-height: 26px;
                    }
                }
            }
            &-img{
                margin-top: 40px;
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                align-content: center;
                justify-content: center;
                img{
                    max-height: 200px;
                }
                @media screen and (max-width: 992px) {
                    margin-top: 0;
                    img{
                        width: 133px;
                        margin-top: 0;
                    }
                }
            }
        }
    }
}
</style>